import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_USER_HISTORY_QUERY_KEY } from '../../user-history/hooks/useGetUserHistory';

type BulkGrantCreditsInput = {
  cohortId: string;
  amount: number;
  reason: string;
};

type BulkGrantCreditsResult = {
  totalUsers: number;
  successCount: number;
  errorCount: number;
  errors: { userId: string; reason: string }[];
};

export const useBulkGrantCredits = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['bulkGrantCredits'],
    mutationFn: async (input: BulkGrantCreditsInput) => {
      return client.fetchApi<BulkGrantCreditsResult, BulkGrantCreditsInput>({
        endpoint: 'wallet/admin/bulk-grant',
        method: 'POST',
        body: input,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wallet'] });
      // Bulk grant doesn't know which cohort members are currently open on a
      // UserPage — invalidate every admin-user-history query broadly (no
      // userId segment) rather than none, same reasoning as
      // useAdminAdjustWallet's fix (T8@eng-review): 'wallet' never covered
      // this different top-level query key.
      queryClient.invalidateQueries({ queryKey: [GET_USER_HISTORY_QUERY_KEY] });
    },
  });
};
